<template>
	<div class="container">
		<div class="mr-navbar-container">
			<div class="mr-badge"><router-link :to="{ path: '/' }">Madnight Radio</router-link> <span :class="`fa fa-${themeIcon}-o`" @click="toggleTheme"></span></div>
			<div :class="`mr-hamburger` + (this.hamburgerOpen == true ? ` is-active` : ``)" @click="toggleHamburger">
				<span class="fa fa-bars"></span>
			</div>
			<ul class="mr-navbar-items">
				<li v-for="(item, index) in navItems" class="mr-navbar-item" :key="index">
					<router-link v-if="item.nonRouter !== true" :to="{ path: item.link }">{{ item.title }}</router-link>
					<a v-else :href="item.link">{{ item.title }}</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import {EventBus} from '../../main';
import RadioTheme from '../../theme';

export default {
	name: 'navbar',
	data () {
		return {
			hamburgerOpen: false,
			navItems: [
				{ link: '/', title: 'Now Playing' },
				{ link: '/#recent', title: 'Recently Played' },
				{ link: '/#popular', title: 'Popular Tracks' },
				{ link: '/history', title: 'History' }
			],
			themeIcon: "moon"
		}
	},

	mounted () {
		document.addEventListener('click', (e) => {
			if (e.target.className.indexOf('hamburger') > -1 || e.target.className.indexOf('fa-bars') > -1)
				return;

			this.hamburgerOpen = false;
		});

		this.setThemeIcon();
	},

	methods: {
		toggleHamburger () {
			this.hamburgerOpen = !this.hamburgerOpen;
		},

		toggleTheme () {
			let currentTheme = RadioTheme.isDarkModeEnabled();
			RadioTheme.setDarkModeEnabled(!currentTheme);

			EventBus.$emit("toggleTheme", !currentTheme);
			this.setThemeIcon();
		},

		setThemeIcon () {
			this.themeIcon = (RadioTheme.isDarkModeEnabled() === false ? "moon" : "sun");
		}
	}
}
</script>

<style lang="scss" scoped>
	.mr-navbar-container {
		height: $navbar-height;

		.mr-badge {
			align-items: center;
			display: flex;
			float: left;
			font-weight: bold;
			font-size: 1.5rem;
			line-height: $navbar-height;

			.fa {
				cursor: pointer;
				margin-left: 20px;
			}
		}

		.mr-hamburger {
		    display: none;
		    float: right;
		    height: 100%;
		}

		.mr-navbar-items {
			background: transparent;
			display: inline-block;
			float: right;
			height: $navbar-height;
			line-height: $navbar-height;
			list-style: none;

			.mr-navbar-item {
				clear: none;
				display: inline-block;
				float: left;
				height: 100%;
				min-width: 100px;
				text-align: center;

				a {
					display: inline-block;
					height: 100%;
					margin: 0 14px;
					width: 100%;

					&:hover {
						background: darken(#FFF, 10%);
					}
				}
			}
		}

		@include mobile {
		    .mr-navbar-items {
		    	border-bottom: 1px solid $default-border-col;
				height: auto;
				left: 0;
				max-height: 0;
				overflow: hidden;
				position: absolute;
				top: 100%;
				transition: max-height .25s ease-in-out;
				width: 100%;

				.mr-navbar-item {
					clear: both;
					text-align: center;
					width: 100%;
				}
		    }

			.mr-hamburger {
				cursor: pointer;
				display: inline-block;

				.fa-bars {
					font-size: 1.5rem;
					height: $navbar-height;
					line-height: $navbar-height;
				}

				&.is-active {
					+ .mr-navbar-items {
						display: inline-block;
						max-height: 100vh;
						z-index: 200;
					}
				}
			}
		}
	}

	@include mobile {
		.container {
			padding: 0 15px;
			position: relative;
			width: 100%;
		}
	}

	body.is-dark .mr-navbar-container {
		.mr-navbar-items {
			background: $dark-background;

			.mr-navbar-item {
				a:hover {
					background: lighten($dark-background, 10%);
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// Navbar.vue?68f81c3f